export default __webpack_public_path__ + "static/media/logo-b.4b7d0075.png";